// dateUtils.j
export const formatLocalDateTime = (utcDate, mode = "UTC") => {
  if (!utcDate) return "-";

  const date = new Date(utcDate);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

    if (mode === "UTC") {
    const formatted = date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "UTC",
    });
    return `${formatted} (UTC)`;
  }


   const formatted = date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
    const offset = getUtcOffsetLabel(date);
  return `${formatted} (${offset})`;
};
// Helper: compute UTC offset like "UTC+05:30" or "UTC-04:00"
const getUtcOffsetLabel = (date) => {
  const offsetMinutes = -date.getTimezoneOffset(); // JS gives inverted sign
  const sign = offsetMinutes >= 0 ? "+" : "-";
  const absMinutes = Math.abs(offsetMinutes);
  const hours = String(Math.floor(absMinutes / 60)).padStart(2, "0");
  const minutes = String(absMinutes % 60).padStart(2, "0");
  return `UTC${sign}${hours}:${minutes}`;
};